<template>
  <div class="mt-0 pt-0" id="App">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#App {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<style>
@import "./assets/css/css/jquery.fancybox.min.css";
@import "./assets/css/css/main.css";
@import "./assets/css/css/gridpak.css";
</style>